export const baseURL = 'https://dev.pugcrm.com/crmapi/';
export const defaultImage = `${baseURL}/upload/default/male.jpg`;
export const imageURL = 'https://pugcrm.s3.ap-south-1.amazonaws.com/dev' ;